import React from 'react';

const ModalPedidoExistente = ({ show, handleClose, handleVerMiPedido, handleEliminarYRehacer, mensaje }) => {
  if (!show) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={handleClose}
    >
      <div 
        className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-yellow-500 text-white px-6 py-4 rounded-t-lg flex items-center gap-2">
          <span className="text-2xl">⚠️</span>
          <h2 className="text-xl font-bold">Ya tenés pedidos realizados</h2>
        </div>
        
        <div className="p-6 text-center">
          <p className="text-gray-800 mb-3 text-base">
            {mensaje || 'Ya tenés un pedido guardado para esta fecha y comida.'}
          </p>
          <p className="text-gray-600 text-sm">
            Podés ver tu pedido actual o eliminarlo todo para volver a empezar.
          </p>
        </div>
        
        <div className="px-6 pb-6 flex flex-col sm:flex-row gap-3 justify-center">
          <button 
            onClick={handleVerMiPedido}
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-lg transition-colors"
          >
            📋 Ver Mi Pedido
          </button>
          <button 
            onClick={handleEliminarYRehacer}
            className="bg-red-600 hover:bg-red-700 text-white font-semibold px-6 py-3 rounded-lg transition-colors"
          >
            🗑️ Borrar todo y volver a empezar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalPedidoExistente;
